import React, {useContext} from "react";
import { buyNowContext } from "../BuyNow";

export const FreeScaleOffer = () => {
  const { isProduction } = useContext(buyNowContext);

  const stripPaymentLinkUrl = isProduction ? "https://buy.stripe.com/7sI5mUfHT7faaDC3dU" : "https://buy.stripe.com/test_6oE8yo5dHbKGdWMbII";

  return (
    <div className="col col-10 col-lg-6 mx-auto mt-4 mb-4">
      <a className={'d-flex flex-column align-items-center'} target="_blank" href={stripPaymentLinkUrl}>
        <img
          src={'/img/buyNow/interest-free-oak-lifetime.png'}
          alt={'/img/buyNow/interest-free-oak-lifetime.png'}
          className="img-fluid"
        />
        <button className={"teal offer-button button-link next-button-txt next-step-button shipping-info-btn"} style={{ fontSize: "20px" }}>
          CLICK HERE TO CLAIM THE OFFER
        </button>
      </a>
    </div>
  );
}
